var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#373635",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.002,
    d: "M19.875 4.5H4.125c-1.036 0-1.875.84-1.875 1.875v11.25c0 1.035.84 1.875 1.875 1.875h15.75c1.035 0 1.875-.84 1.875-1.875V6.375c0-1.036-.84-1.875-1.875-1.875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#373635",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.002,
    d: "m5.251 7.5 6.75 5.25 6.75-5.25"
  })));
};
export default SvgMail;